import { render, staticRenderFns } from "./rulerWrapper.vue?vue&type=template&id=0e058aae&scoped=true&"
import script from "./rulerWrapper.vue?vue&type=script&lang=js&"
export * from "./rulerWrapper.vue?vue&type=script&lang=js&"
import style0 from "./rulerWrapper.vue?vue&type=style&index=0&id=0e058aae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e058aae",
  null
  
)

export default component.exports